(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buscador-modelo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-model-finder]').forEach((root) => {
    const input = root.querySelector('[role="combobox"]');
    const results = root.querySelector('[role="listbox"]');
    const status = root.querySelector('[aria-live="polite"]');
    const empty = root.querySelector('.model-finder__empty');
    const requestLink = root.querySelector('.model-finder__request');
    const modal = root.querySelector('[data-model-modal]');
    const dialog = root.querySelector('[role="dialog"]');
    const modalStatus = root.querySelector('[data-model-modal-status]');
    const formSlot = root.querySelector('[data-model-form-slot]');
    const modalCloseButtons = root.querySelectorAll('[data-model-modal-close]');
    let mountedForm = null;
    let formHome = null;
    let formNextSibling = null;
    let previouslyFocused = null;
    let formWaiter = null;
    let inlineFormWaiter = null;
    let validationObserver = null;
    const words = (value) => value
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .toLowerCase()
      .replace(/\+/g, ' plus ')
      .match(/[a-z0-9]+/g) || [];

    let modelValues;
    try {
      modelValues = JSON.parse(root.dataset.modelValues || '[]');
      if (!Array.isArray(modelValues)) modelValues = [];
    } catch (error) {
      modelValues = [];
    }
    const data = {
      collection_url: root.dataset.collectionUrl,
      param_name: 'filter.v.option.dispositivo',
      models: modelValues.filter((value) => typeof value === 'string' && value.split(' | ').length === 3).map((value) => {
        const parts = value.split(' | ');
        const brand = parts[0];
        const prefix = brand === 'Apple' ? '' : brand === 'Samsung' ? 'Samsung Galaxy ' : `${brand} `;
        return { label: `${prefix}${parts.at(-1)}`, value };
      })
    };

    if (data.models.length === 0) {
      input.disabled = true;
      empty.querySelector('p').textContent = root.dataset.loadError;
      empty.hidden = false;
    }

    const closeResults = () => {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };

    const openModel = (model) => {
      try {
        sessionStorage.setItem('karkasa_selected_model', model.value);
        } catch (error) {}
      const url = new URL(data.collection_url, window.location.origin);
      url.searchParams.set(data.param_name, model.value);
      window.location.assign(url.toString());
    };

    const searchableModelText = (model) => {
      const parts = model.value.split(' | ');
      const brand = parts[0];
      const exactModel = parts.at(-1);
      const alias = brand === 'Samsung' ? 'Galaxy' : brand === 'Redmi' ? 'Xiaomi' : '';
      return words(`${brand} ${alias} ${exactModel}`).join('');
    };

    const render = () => {
      const queryWords = words(input.value);
      results.replaceChildren();
      status.textContent = '';
      empty.hidden = true;

      if (queryWords.join('').length < 2) {
        closeResults();
        return;
      }

      const matches = data.models
        .filter((model) => queryWords.every((word) => searchableModelText(model).includes(word)))
        .slice(0, 8);

      if (matches.length === 0) {
        closeResults();
        empty.hidden = false;
        status.textContent = root.dataset.emptyStatus;
        return;
      }

      matches.forEach((model) => {
        const option = document.createElement('button');
        option.className = 'model-finder__option';
        option.type = 'button';
        option.setAttribute('role', 'option');
        option.textContent = model.label;
        option.addEventListener('click', () => openModel(model));
        results.append(option);
      });

      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      const countLabel = matches.length === 1 ? root.dataset.resultLabel : root.dataset.resultsLabel;
      status.textContent = `${matches.length} ${countLabel}`;
    };

    input.addEventListener('input', render);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeResults();
      if (event.key === 'ArrowDown' && !results.hidden) {
        event.preventDefault();
        results.querySelector('[role="option"]')?.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeResults();
    });

    const findRequestForm = () => document.querySelector('#globo-formbuilder-152420')
      || document.querySelector('.globo-formbuilder[data-id="MTUyNDIw"]')
      || document.querySelector('#modelo-no-disponible')
      || document.querySelector('[id^="152420-"]')?.closest('.globo-formbuilder, form');

    const concealInlineRequestForm = () => {
      const form = document.querySelector('#globo-formbuilder-152420')
        || document.querySelector('[id^="152420-"]')?.closest('.globo-formbuilder, form');
      if (!form) return false;
      if (formSlot.contains(form)) return true;

      const formSection = form.closest('.shopify-section');
      if (formSection) formSection.hidden = true;
      return true;
    };

    let concealAttempts = 0;
    if (!concealInlineRequestForm()) {
      inlineFormWaiter = window.setInterval(() => {
        concealAttempts += 1;
        if (concealInlineRequestForm() || concealAttempts >= 50) {
          window.clearInterval(inlineFormWaiter);
        }
      }, 100);
    }

    const focusFirstFormField = () => {
      const firstField = mountedForm?.querySelector('input:not([type="hidden"]), select, textarea, button');
      window.setTimeout(() => firstField?.focus({ preventScroll: true }), 100);
    };

    // 23/09/2026 · #4: bloquea el autocompletado del navegador en Marca y Modelo
    // y declara Email como campo de email (teclado y autorrelleno correctos en móvil).
    const hardenRequestFields = () => {
      if (!mountedForm) return;
      const setAttributes = (element, attributes) => {
        if (!element) return;
        Object.entries(attributes).forEach(([name, value]) => {
          if (element.getAttribute(name) !== value) element.setAttribute(name, value);
        });
      };
      const textFieldAttributes = { autocomplete: 'off', autocorrect: 'off', spellcheck: 'false' };
      setAttributes(mountedForm.querySelector('input[name="text-1"]'), textFieldAttributes);
      setAttributes(mountedForm.querySelector('input[name="text"]'), textFieldAttributes);
      setAttributes(mountedForm.querySelector('input[name="email"]'), {
        type: 'email',
        autocomplete: 'email',
        inputmode: 'email',
        autocapitalize: 'none',
        autocorrect: 'off',
        spellcheck: 'false'
      });
    };

    const translateValidationMessages = () => {
      if (!mountedForm) return;
      hardenRequestFields();
      const translations = {
        'Marca is required': 'La marca es obligatoria.',
        'Modelo exacto is required': 'El modelo exacto es obligatorio.',
        'Email is required': 'El correo electrónico es obligatorio.',
        'Email address is invalid': 'El correo electrónico no es válido.'
      };
      mountedForm.querySelectorAll('*').forEach((element) => {
        if (element.children.length !== 0) return;
        const original = element.textContent.trim();
        if (translations[original]) element.textContent = translations[original];
      });
    };
    const mountRequestForm = () => {
      const form = findRequestForm();
      if (!form || formSlot.contains(form)) return Boolean(form);

      mountedForm = form;
      formHome = form.parentNode;
      formNextSibling = form.nextSibling;
      formSlot.append(form);
      translateValidationMessages();
      validationObserver?.disconnect();
      validationObserver = new MutationObserver(translateValidationMessages);
      validationObserver.observe(form, { childList: true, subtree: true, characterData: true });
      modalStatus.hidden = true;
      focusFirstFormField();
      return true;
    };

    const restoreRequestForm = () => {
      if (!mountedForm || !formHome) return;
      validationObserver?.disconnect();
      validationObserver = null;
      if (formNextSibling?.parentNode === formHome) {
        formHome.insertBefore(mountedForm, formNextSibling);
      } else {
        formHome.append(mountedForm);
      }
      mountedForm = null;
      formHome = null;
      formNextSibling = null;
    };

    const closeModal = () => {
      if (modal.hidden) return;
      window.clearInterval(formWaiter);
      restoreRequestForm();
      modal.hidden = true;
      document.body.classList.remove('model-finder-modal-open');
      previouslyFocused?.focus();
    };

    const openModal = () => {
      previouslyFocused = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('model-finder-modal-open');
      modalStatus.hidden = false;
      modalStatus.textContent = root.dataset.modalLoading;
      dialog.focus();

      if (mountRequestForm()) return;

      let attempts = 0;
      formWaiter = window.setInterval(() => {
        attempts += 1;
        if (mountRequestForm()) {
          window.clearInterval(formWaiter);
        } else if (attempts >= 20) {
          window.clearInterval(formWaiter);
          modalStatus.textContent = root.dataset.modalError;
        }
      }, 100);
    };

    requestLink?.addEventListener('click', (event) => {
      event.preventDefault();
      openModal();
    });

    modalCloseButtons.forEach((button) => button.addEventListener('click', closeModal));

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = [...modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )].filter((element) => element.offsetParent !== null);
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
